import { all, fork, put, takeEvery } from 'redux-saga/effects';
// redux actions
import * as actionType from './actionTypes';
import * as actions from './actions';
// Api methods
import { api } from 'api';
// interface
import { AxiosResponse } from 'axios';
import { Hardware } from 'api';

export interface IHardwarePayload {
	payload: string;
	type: string;
}

function* fetchHardwareList({ payload }: IHardwarePayload) {
	try {
		const response: AxiosResponse<Hardware[]> =
			yield api.hardware.apiHardwareDataGet();
		yield put(actions.getHardwareSuccess(response.data)); // {hardware: response.data}
	} catch (error: any) {
		//yield put(actions.getDropdownError(error));
		console.log('error happened in hardware list fetch');
		yield put(actions.getHardwareError(error)); // {hardware: response.data}
	}
}

export function* watchfetchHardwareList() {
	yield takeEvery(actionType.GET_HARDWARE, fetchHardwareList);
}

function* hardwareSaga() {
	yield all([fork(watchfetchHardwareList)]);
}

export default hardwareSaga;
